<div class="title-panel">
    Configuração de D/Para
</div>
<mat-divider></mat-divider>
<div class="info">
    Definição de D/Para da Etapa, serão definidas regras para vincular as informações de origem e destino.
</div>

<mat-divider></mat-divider>


<mat-toolbar>
    <mat-toolbar-row>
        <button mat-mini-fab color="primary"  matTooltip="Adicionar" *ngIf="!editFace" (click)="add()" matTooltipClass="toolTip-request" [disabled]="!canInsert">
            <mat-icon>add</mat-icon>
        </button>
        <span class="space4"></span>
        <button mat-mini-fab color="warn"  matTooltip="Remover" *ngIf="!editFace" (click)="remove()" matTooltipClass="toolTip-request" [disabled]="!canDelete">
            <mat-icon>delete</mat-icon>
        </button>
        <button mat-mini-fab color="success"  matTooltip="Salvar" *ngIf="editFace" (click)="save()" matTooltipClass="toolTip-request" [disabled]="!canEdit">
            <mat-icon>check</mat-icon>
        </button>
        <span class="space4"></span>
        <button mat-mini-fab color="accent"  matTooltip="Cancelar" *ngIf="editFace" (click)="editFace=false;sequenceFt=null" matTooltipClass="toolTip-request">
            <mat-icon>close</mat-icon>
        </button>
        <mat-divider [vertical]="true" *ngIf="!editFace" ></mat-divider>
        <button mat-mini-fab  color="accent" matTooltip="Atualizar" matTooltipClass="toolTip-request"  (click)="refresh()" *ngIf="!editFace" [disabled]="!canView"> 
            <mat-icon  aria-hidden="accent" >refresh</mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>
<ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name='dparaform'>
</ngx-spinner>
<div class="cid-main mat-elevation-z8" *ngIf="!editFace">
    <ag-grid-angular
        style="width: 100%; height: 100%"
        [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
        [rowData]="rows"
        [columnDefs]="displayedColumns"
        (gridReady)="onGridReady($event)"
        (rowDoubleClicked)="selectRow($event)"
        (rowClicked)="eventGridSelect($event)"
        [localeText]="ls.getCurrentGridLocale()"
        overlayNoRowsTemplate="Não encontrado nenhum resultado"
        rowBuffer="150"
        rowSelection="multiple"
        cacheBlockSize= "100"
        cacheOverflowSize="2"
        maxBlocksInCache= 10
        resizable="true"
        [pagination]="true"
        [multiSortKey]="true">
    </ag-grid-angular>
    <!--mat-table  [dataSource]="columns" class="mat-elevation-z8">
        <ng-container matColumnDef="sequenceft">
        <th mat-header-cell *matHeaderCellDef> Sequência</th>
        <td mat-cell *matCellDef="let column"> {{column.SEQUENCEFT}} </td>
        </ng-container>

        <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef> Ativo </th>
        <td mat-cell *matCellDef="let column"> <div [ngClass]="column.ACTIVE=='S'?'active':'inactive'">{{getDesc(column.ACTIVE,'ACTIVE')}}</div></td>
        </ng-container>

        <ng-container matColumnDef="datatype">
        <th mat-header-cell *matHeaderCellDef> Tipo de Processo </th>
        <td mat-cell *matCellDef="let column"><div class="row"> {{column.DATATYPE}} - {{getDesc(column.DATATYPE,'DATATYPE')}} </div></td>
        </ng-container>

        <ng-container matColumnDef="contenttype">
            <th mat-header-cell *matHeaderCellDef> Tipo de Dado</th>
            <td mat-cell *matCellDef="let column"><div class="row">  {{column.CONTENTTYPE}} - {{getDesc(column.CONTENTTYPE,'CONTENTTYPE')}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="fromdata">
            <th mat-header-cell *matHeaderCellDef>De</th>
            <td mat-cell *matCellDef="let column"> <div class="row"> {{column.FROMDATA}}</div></td>
        </ng-container>

        <ng-container matColumnDef="todata">
            <th mat-header-cell *matHeaderCellDef>Para</th>
            <td mat-cell *matCellDef="let column"> <div class="row">  {{column.TODATA}}</div> </td>
        </ng-container>

        <ng-container matColumnDef="expression">
            <th mat-header-cell *matHeaderCellDef>Expressão</th>
            <td mat-cell *matCellDef="let column"><div class="row">{{column.EXPRESSION}}</div> </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">Nenhum D/Para cadastrado</td>
        </tr>
    </mat-table-->
</div>
<div class="cid-main" *ngIf="editFace">
    <mat-stepper  #stepper>
        <mat-step [stepControl]="firstFormGroup" >
            <form [formGroup]="firstFormGroup">
                <ng-template matStepLabel>Informação Inicial</ng-template>
                <div class="step" #step>
                    <suspended-menu [title]="titleFrom" [show]="showSuspendedMenuFrom" [data]="supendedDataFrom" [dropprefix]="prefixFrom" heigth="170"></suspended-menu>
                    <suspended-menu [title]="titleTo" [show]="showSuspendedMenuTo" [data]="supendedDataTo" [dropprefix]="prefixTo" heigth="170"></suspended-menu>
                    <div class="more-options">
                        <mat-slide-toggle   [(ngModel)]="active"  [ngModelOptions]="{standalone: true}" (change)="onToggleChange('ACTIVE')">Ativo
                        </mat-slide-toggle>
                    </div>
                    <mat-divider></mat-divider>
                    <mat-form-field [formGroup]="firstFormGroup"  class="no-padding-form-field-5px full-width">
                        <mat-label>Tipo de Processo</mat-label>
                        <mat-select formControlName="DATATYPE" (selectionChange)="changeDataType($event)">
                        <mat-option *ngFor="let item of dataTypeCodesReal|arrayFilter:'active':'true':false:false" [value]="item.dataType" [matTooltip]="item.toolTip" matTooltipClass="toolTip-request">
                            {{item.dataType}} - {{item.name}}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field [formGroup]="firstFormGroup"  class="no-padding-form-field-5px full-width">
                        <mat-label>Tipo de Dado</mat-label>
                        <mat-select formControlName="CONTENTTYPE">
                        <mat-option *ngFor="let item of contentTypeCodes" [value]="item.contentType">
                            {{item.contentType}} - {{item.name}}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-grid-list cols="2" rowHeight="60px" gutterSize="6px">
                        <mat-grid-tile *ngIf="showD">
                            <mat-form-field [formGroup]="firstFormGroup"  appearance="outline" class="no-padding-form-field-5px full-width" >
                                <mat-label>De</mat-label>
                                <input  tabindex="1" type = "text" matInput formControlName="FROMDATA" placeholder="Nome da Tag"  required #inpfrom matTooltip="Informar o nome do D" matTooltipClass="toolTip-request"> 
                                <button    tabindex="-1"   type="button" *ngIf="inpfrom.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpfrom.value=''" >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </mat-grid-tile>
                        <mat-grid-tile [colspan]="!showD?'2':'1'">
                            <mat-form-field [formGroup]="firstFormGroup"  appearance="outline" class="no-padding-form-field-5px full-width">
                                <mat-label>Para</mat-label>
                                <input  tabindex="1" type = "text" matInput formControlName="TODATA" placeholder="Nome da Tag"  required #inptodata matTooltip="Informar o nome do Para" matTooltipClass="toolTip-request"> 
                                <button    tabindex="-1"   type="button" *ngIf="inptodata.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inptodata.value=''" >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </mat-grid-tile>
                    </mat-grid-list>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup" [editable]="!disableExpression">
            <form [formGroup]="secondFormGroup">
                <ng-template matStepLabel>Expressão</ng-template>
                <div class="step">
                    <div class="query-text">
                        <mat-form-field appearance="outline" [formGroup]="secondFormGroup" ngClass="customtextarea no-padding-form-field fill-container" >
                            <mat-label>Expressão</mat-label>
                            <textarea  matInput type="text"  formControlName="EXPRESSION" #inpExpression>
                            </textarea>
                            <button  *ngIf="showFormula"  tabindex="-1"   type="button" matSuffix mat-icon-button aria-label="Clear"  (click)="openFormula(inpExpression.value, 'EXPRESSION', secondFormGroup)" >
                                <mat-icon>bolt</mat-icon>
                            </button>
                            <button  *ngIf="!showFormula"  tabindex="-1"   type="button" matSuffix mat-icon-button aria-label="Clear"  (click)="openQuery(inpExpression.value, 'EXPRESSION', secondFormGroup)" >
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-step>
        <mat-step [stepControl]="thirdFormGroup" [editable]="!disableOthers">
            <form [formGroup]="thirdFormGroup">
                <ng-template matStepLabel>+ Opções</ng-template>
                <div class="step">

                </div>
            </form>
        </mat-step>
    </mat-stepper>
</div>
